import React from "react";
import { Helmet } from "react-helmet";

import Page from "../../components/layout/Page";

//@ts-ignore
import showroomBg from "../../assets/images/showroom-hero.jpg";
//@ts-ignore
import cat1 from "../../assets/images/consultanta.jpg";
//@ts-ignore
import img1 from "../../assets/images/pages/1.jpg";
//@ts-ignore
import img2 from "../../assets/images/pages/2.jpg";

export default function Consultanta() {
  return (
    <Page>
      {
        //@ts-ignore
        <Helmet>
          <title>
            Proiectare Case Inteligente & Consultanță Smart Home | Asempera Cluj
          </title>
          <meta
            name="description"
            content={`Transformă-ți visul în realitate cu Asempera. Oferim consultanță și proiectare personalizată pentru case inteligente în Cluj-Napoca și toată România. Creează un cămin confortabil, sigur și eficient.`}
          />
        </Helmet>
      }
      <div
        className="page-title with-background"
        style={{ backgroundImage: `url(${cat1})` }}
      >
        <div className="shade"></div>
        <h1>Consultanță & proiectare</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <p>
            Proiectul tău merită mai mult decât o soluție standard. La Asempera,
            proiectăm mai mult decât circuite și senzori;{" "}
            <strong>proiectăm experiențe</strong>. Oferim consultanță
            specializată pentru a crea un{" "}
            <strong>sistem smart home perfect integrat</strong>, care îți
            simplifică viața și îți reflectă stilul unic.<br></br>
            <br></br>
            Imaginează-ți o dimineață în care casa te trezește lent, ridicând
            jaluzelele și pornind melodia preferată, în timp ce aroma cafelei
            proaspete te întâmpină. Imaginează-ți o seară în care, cu o singură
            comandă vocală, luminile se diminuează, televizorul pornește și casa
            se pregătește pentru relaxare.
            <br></br>
            <br></br>
            Acesta nu este un scenariu SF, ci realitatea unei case inteligente
            proiectate corect. Misiunea noastră este să transformăm această
            viziune în planul tău concret. Fie că ești din Cluj-Napoca sau din
            orice alt colț al țării, echipa noastră de specialiști în
            automatizări rezidențiale este aici pentru a te ghida.
          </p>
        </div>
      </div>
      <div className="an-section bg-1">
        <div className="an-content flex align-center">
          <div className="an-col w-6">
            <h2>Cum prinde viață proiectul tău de casă inteligentă?</h2>
            <p className="mb-0">
              Credem într-un parteneriat. Procesul nostru este un dialog
              continuu, nu o listă de sarcini. <br></br>
              <br></br>Totul începe cu povestea ta. Stăm de vorbă, ascultăm cum
              trăiești, ce te motivează și ce ți-ar face viața mai ușoară. Pe
              baza acestor discuții, conturăm scenarii de automatizare care ți
              se potrivesc perfect. <br></br>
              <br></br>Apoi, experții noștri transformă această viziune într-un
              limbaj tehnic.{" "}
              <strong>Proiectăm de la zero întreaga infrastructură.</strong>{" "}
              Alegem cu grijă cele mai fiabile tehnologii și echipamente care să
              funcționeze împreună, integrând iluminatul, climatizarea,
              securitatea și sistemele media într-un singur creier inteligent.
              La final, îți predăm un{" "}
              <strong>proiect de automatizare complet</strong>, gata să fie adus
              la viață.
            </p>
          </div>
          <div className="an-col w-6">
            <img src={img2} className="max-400 center"></img>
          </div>
        </div>
      </div>
      <div className="an-section">
        <div className="an-content flex align-center">
          <div className="an-col w-6 order-2-mobile">
            <img src={img1} className="max-400 center"></img>
          </div>
          <div className="an-col w-6 order-1-mobile">
            <h2>Beneficiile unei case inteligente proiectate de Asempera:</h2>
            <p>
              <strong>Confort absolut:</strong> Uită de zeci de întrerupătoare
              și telecomenzi. Preia controlul total dintr-o aplicație elegantă
              sau prin simple comenzi vocale. Creează ambianța perfectă pentru
              cină, lucru sau petrecere, instantaneu. Casa ta se adaptează ție,
              nu invers.
            </p>
            <p>
              <strong>Siguranța pe care te poți baza 24/7:</strong> Dormi
              liniștit știind că locuința ta este protejată. Primești alerte pe
              telefon dacă un senzor detectează fum sau o inundație. Verifică
              camerele de supraveghere și încuie ușa de la distanță. O casă
              inteligentă îți oferă pacea sufletească pe care o meriți.
            </p>
            <p>
              <strong>
                Eficiență energetică inteligentă, pentru facturi mai mici:
              </strong>{" "}
              Investiția într-un sistem smart home se reflectă direct în
              economii. Casa ta va ști să nu irosească energia: va stinge
              luminile în camerele goale, va ajusta termostatul inteligent când
              pleci și va folosi jaluzelele pentru a menține o temperatură
              optimă. Este o soluție prietenoasă atât cu bugetul tău, cât și cu
              planeta.
            </p>
          </div>
        </div>
      </div>
      <div id="showroom">
        <div
          className="bg-section"
          style={{ backgroundImage: `url(${showroomBg})` }}
        ></div>
        <div className="shade"></div>
        <div className="an-section">
          <div className="an-content flex center">
            <div className="an-col w-8 text">
              <h1>E timpul să faci primul pas către casa viitorului.</h1>
              <p>
                Nu trebuie să fii expert în tehnologie, de asta ne ocupăm noi.
                Suntem aici să îți răspundem la întrebări și să îți arătăm ce
                este posibil.
              </p>
              <p>
                Hai să discutăm proiectul tău, virtual sau la sediul nostru din
                Cluj-Napoca și să conturăm împreună viitorul casei tale.
              </p>
              <p className="small-notice">
                Statutul de Partener Oficial Loxone ne certifică expertiza și ne
                obligă la excelență. Alegând Asempera, alegeți o echipă de
                încredere, instruită și validată direct de producător, gata să
                implementeze cele mai avansate soluții de automatizare Loxone.
              </p>
              <a
                className="special-button"
                style={{ marginTop: 16 }}
                href="/#contact"
              >
                Hai să discutăm proiectul tău.
              </a>
            </div>
            <div className="an-col w-4 blank"></div>
          </div>
        </div>
      </div>
    </Page>
  );
}
